import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    user: null,
    customer: null,
    token: null,
    loading: true,
};
const sessionSlice = createSlice({
    name: "session",
    initialState,
    reducers: {
        setSession(state, action) {
            state.user = action.payload.user;
            state.customer = action.payload.customer;
            state.token = action.payload.token;
            state.loading = false;
        },
        clearSession(state) {
            state.user = null;
            state.customer = null;
            state.token = null;
            state.loading = false;
        },
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setToken(state, action) {
            state.token = action.payload;
        },
        setCustomer(state, action) {
            state.customer = action.payload;
        },
        setUser(state, action) {
            state.user = action.payload;
        },
    },
});
export const { setSession, clearSession, setToken, setLoading, setCustomer, setUser } = sessionSlice.actions;
export default sessionSlice.reducer;
export const sessionSelector = (state) => state.session;
